/** Desktop pagination window (matches prior search page behavior). */
export function getPaginationItems(
  current: number,
  totalPages: number
): ReadonlyArray<number | "…"> {
  if (totalPages <= 8) return Array.from({ length: totalPages }, (_, i) => i + 1);

  if (current <= 4)
    return [1, 2, 3, 4, 5, 6, "…", totalPages] as const;

  if (current >= totalPages - 3)
    return [
      1,
      "…",
      totalPages - 4,
      totalPages - 3,
      totalPages - 2,
      totalPages - 1,
      totalPages,
    ] as const;

  return [1, "…", current - 1, current, current + 1, "…", totalPages] as const;
}

/** Mobile: at most 4 page numbers. */
export function getMobilePaginationItems(
  current: number,
  totalPages: number
): ReadonlyArray<number> {
  if (totalPages <= 4) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  if (current <= 2) {
    return [1, 2, 3, 4] as const;
  }

  if (current >= totalPages - 1) {
    return [
      totalPages - 3,
      totalPages - 2,
      totalPages - 1,
      totalPages,
    ] as const;
  }

  return [current - 1, current, current + 1, current + 2] as const;
}
